import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export function usePageTitle(activeTab: any, activeNavItem: any) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (pathname.includes('explore')) {
      setTitle(t('page.title.explore'));
    } else if (pathname.includes('support')) {
      setTitle(t('page.title.support'));
    } else if (pathname.includes('accessibility-statement')) {
      setTitle(t('page.title.accessibilityStatement'));
    } else if (pathname.includes('profile')) {
      const profileTitle = t('page.title.profile');
      if (pathname.includes('settings')) {
        setTitle(`${t('page.title.settings')} - ${profileTitle}`);
      } else if (pathname.includes('invite')) {
        setTitle(`${t('page.title.invite')} - ${profileTitle}`);
      } else if (pathname.includes('stats')) {
        setTitle(`${t('page.title.stats')} - ${profileTitle}`);
      }
    } else if (pathname.includes('for-you')) {
      setTitle(t('page.title.for-you'));
    } else if (pathname.includes('media')) {
      const contentTitle = decodeURIComponent(pathname.split('/').pop()).replace(/_/g, ' ');
      setTitle(
        `${contentTitle} - ${t('page.title.player')} - ${t('page.title.media')} - Champion Health`
      );
    } else if (
      pathname.includes('programme') ||
      pathname.includes('masterclass') ||
      pathname.includes('take-actions')
    ) {
      const mediaType = pathname.split('/')[1];
      const contentTitle = decodeURIComponent(pathname.split('/').pop()).replace(/_/g, ' ');
      setTitle(`${contentTitle} - ${t(`page.title.${mediaType}`)}`);
    } else {
      const activeTabTitle = activeTab ? t(`nav.pages.${activeTab.code}`) : '';
      const activeNavItemTitle = activeNavItem ? `- ${t(`nav.pages.${activeNavItem?.code}`)}` : '';
      const healthAreaTitle = `- ${t('page.title.healthArea')}`;

      setTitle(`${activeTabTitle} ${activeNavItemTitle} ${healthAreaTitle}`);
    }
  }, [pathname, activeNavItem, activeTab]);

  return title;
}
